import { Campaign } from '~/types';
import { useMutation } from '~/utils/rq';

export type UpsertDraftCampaignVariables = Omit<Campaign, 'client_name'> & {
  client_name?: string;
};

export const useUpsertDraftCampaign = (campaignId?: string) => {
  const qs = '?include_baseline_questions=true';
  const url = !!campaignId
    ? `/campaigns/${campaignId}${qs}`
    : `/campaigns${qs}`;
  const method = !!campaignId ? 'put' : 'post';

  return useMutation<UpsertDraftCampaignVariables, Campaign>(
    {},
    {
      url,
      method
    }
  );
};
